const menuList2 = [
/*   { title: 'Nosotros', to: '#!' },
  { title: 'Contactos', to: '#!' }, */
  { title: 'Términos y condiciones de uso', to: '/terms'},
  { title: 'Política de privacidad', to: '/privacy'}
];
export default menuList2
